export function toStringArray(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value as string[]
  }
  return value ? [value as string] : []
}
